const neighborhoods = [
  { name: "Downtown Kingsport", desc: "Historic Broad Street corridor, Kingsport Town Center, and the Eastman Chemical global headquarters campus. The corporate heart of the Tri-Cities.", icon: "ri-building-line" },
  { name: "Colonial Heights", desc: "Upscale Kingsport neighborhood with professional families and Eastman senior executives. Major shopping and dining corridor along Fort Henry Drive.", icon: "ri-home-line" },
  { name: "Hawkins County / Church Hill", desc: "Western Sullivan County neighbor with direct Eastman commuter access. Church Hill and Rogersville serve chemical industry workers and manufacturing families.", icon: "ri-map-pin-line" },
  { name: "Gate City, Virginia", desc: "Scott County VA border community just 30 miles north. Many Gate City residents work at Eastman and seek Kingsport-area passport services.", icon: "ri-map-2-line" },
  { name: "Mount Carmel / Lynn Garden", desc: "North Kingsport residential neighborhoods with a large manufacturing workforce. Many residents travel internationally for Eastman supplier site visits.", icon: "ri-community-line" },
  { name: "Bristol Border Corridor", desc: "The Tennessee-Virginia state line runs through downtown Bristol, just 18 miles from Kingsport. We serve the entire I-81 corridor between both cities.", icon: "ri-road-map-line" },
];

const employers = [
  { name: "Eastman Chemical Company", desc: "7,000+ employees at the Kingsport headquarters. Global operations in Germany, Netherlands, China, and Singapore create constant international travel demand.", icon: "ri-flask-line" },
  { name: "BAE Systems", desc: "Major defense contractor with Kingsport operations. Employees traveling to UK, Australia, and international defense partner facilities.", icon: "ri-shield-star-line" },
  { name: "Holston Army Ammunition Plant", desc: "Federal government employer with civilian personnel occasionally traveling internationally for technical exchanges and NATO partnership meetings.", icon: "ri-government-line" },
  { name: "Wellmont Health System / Ballad Health", desc: "Regional hospital network with physicians attending international medical conferences, WHO summits, and global health research programs.", icon: "ri-hospital-line" },
];

export default function KingsportLocalAreaSection() {
  return (
    <section id="local-area" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Coverage</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Serving Kingsport & Sullivan County
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            From downtown Kingsport to Gate City VA, from Church Hill to Bristol — we cover the entire Sullivan County and border region.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div>
            <h3 className="font-serif text-2xl font-bold text-[#1A365D] mb-6">Areas We Serve</h3>
            <div className="space-y-4">
              {neighborhoods.map((n, i) => (
                <div key={i} className="flex items-start gap-4 p-5 bg-[#F7F8FA] rounded-xl">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                    <i className={`${n.icon} text-[#1A365D] text-lg`}></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-[#1A365D] mb-1">{n.name}</h4>
                    <p className="text-gray-500 text-sm leading-relaxed">{n.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-serif text-2xl font-bold text-[#1A365D] mb-6">Major Employers We Serve</h3>
            <div className="space-y-4 mb-8">
              {employers.map((e, i) => (
                <div key={i} className="flex items-start gap-4 p-5 bg-[#F7F8FA] rounded-xl">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                    <i className={`${e.icon} text-[#1A365D] text-lg`}></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-[#1A365D] mb-1">{e.name}</h4>
                    <p className="text-gray-500 text-sm leading-relaxed">{e.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="bg-[#1A365D] rounded-xl p-6">
              <h4 className="font-semibold text-white mb-3">Tri-Cities Regional Airport (TRI)</h4>
              <p className="text-white/70 text-sm leading-relaxed mb-4">
                Located 15 minutes from downtown Kingsport, TRI connects to Charlotte, Atlanta, and Washington Dulles — all major international gateway airports. Eastman executives and BAE contractors departing Kingsport connect through these hubs for flights to Europe and Asia.
              </p>
              <div className="flex items-center gap-2 text-[#F6C344] text-sm font-medium">
                <i className="ri-flight-takeoff-line"></i>
                <span>15 minutes from Eastman Chemical HQ</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}